module.exports = __webpack_public_path__ + "img/eronet-logo.858f0026.png";